export default __webpack_public_path__ + "static/media/login-wave-mobile.574f8b3d.svg";